import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/common.css";
import styles from "../assets/css/login.module.css";
import murataLogo from "../assets/images/murata-logo.png";

import authService from "../services/authService";
import { registrationCheckService } from "../services/registrationCheckService";

function Login() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      // トークンがあれば登録状態に応じてリダイレクト
      const redirect = async () => {
        try {
          const {
            hasVisitedWelcome,
            hasMemberData,
            hasRouteData,
            hasPhotoData,
            hasConfidentialityData
          } = await registrationCheckService.checkRegistration();

          if (hasConfidentialityData) {
            navigate("/");
          } else if (hasPhotoData) {
            navigate("/confidentiality-agreement");
          } else if (hasRouteData) {
            navigate("/photo-permission");
          } else if (hasMemberData) {
            navigate("/route-check");
          } else if (hasVisitedWelcome) {
            navigate("/member-registration");
          } else {
            navigate("/welcome");
          }
        } catch {
          navigate("/");
        }
      };
      redirect();
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const data = await authService.login(email, password); // ← サービス経由でログイン処理

      localStorage.setItem("authToken", data.token);
      localStorage.setItem("userRole", data.role);
      localStorage.setItem("userRoleName", data.roleName);

      console.log("ログイン成功:", data);
      
      try {
        const { 
          hasVisitedWelcome, 
          hasMemberData, 
          hasRouteData, 
          hasPhotoData, 
          hasConfidentialityData 
        } = await registrationCheckService.checkRegistration();
        
        if (hasConfidentialityData) {
          navigate("/");
        } else if (hasPhotoData) {
          navigate("/confidentiality-agreement");
        } else if (hasRouteData) {
          navigate("/photo-permission");
        } else if (hasMemberData) {
          navigate("/route-check");
        } else if (hasVisitedWelcome) {
          navigate("/member-registration");
        } else {
          navigate("/welcome");
        }
      } catch (checkError) {
        console.error("登録確認エラー:", checkError);
        navigate("/welcome");
      }
    } catch (error) {
      // エラー表示（API側のメッセージ or ネットワークエラー）
      setErrorMessage(
        "エラーが発生しました: " + (error?.data?.error || error.message)
      );
    }
  };

  return (
    <div className={styles['login-page']}>
      <div className={styles['login-card']}>
        <div className="text-center mb-3">
          <img
            src={murataLogo}
            alt="Murata Logo"
            className={`${styles.logo} mb-3`}
          />
          <h2 className={styles['login-title']}>ログイン</h2>
          <p className="text-muted">
            メールアドレスとパスワードを入力してください。
          </p>
          {errorMessage && (
            <div className="alert alert-danger">{errorMessage}</div>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              メールアドレス
            </label>
            <input
              type="email"
              name="email"
              className="form-control"
              id="email"
              placeholder="メールアドレスを入力"
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              パスワード
            </label>
            <input
              type="password"
              name="password"
              className="form-control"
              id="password"
              placeholder="パスワードを入力"
              required
            />
          </div>

          <div className="d-grid mb-3">
            <button type="submit" className="btn btn-primary">
              ログイン
            </button>
          </div>

          <div className="text-center">
            <small className="text-muted">
              パスワードを忘れた場合は管理者（info@mss-g.co.jp）にお問い合わせください
            </small>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
